function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
  fill: "#FACD40"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2255 29.9928C16.0321 29.9275 15.8609 29.8094 15.731 29.6519C15.5476 29.4293 15.4568 29.1447 15.4772 28.857C15.4977 28.5693 15.6278 28.3004 15.8408 28.1059C16.0644 27.9122 21.3569 23.4837 26.7521 24.3136C29.3619 24.7188 31.5267 26.2561 33.1897 28.8589C33.269 28.9838 33.3227 29.1232 33.3477 29.269C33.3727 29.4148 33.3685 29.5641 33.3353 29.7083C33.3022 29.8525 33.2407 29.9886 33.1545 30.1089C33.0683 30.2291 32.9591 30.3311 32.8333 30.4088C32.5804 30.5669 32.2752 30.6182 31.9846 30.5513C31.6939 30.4845 31.4417 30.305 31.2834 30.0523C29.998 27.9963 28.3585 26.8024 26.4242 26.5063C22.0484 25.8222 17.3624 29.743 17.322 29.7689C17.1743 29.898 16.9956 29.9865 16.8034 30.0257C16.6112 30.065 16.412 30.0536 16.2255 29.9928Z",
  fill: "#676F8F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 19.875C19.3462 19.875 20.4375 18.7837 20.4375 17.4375C20.4375 16.0913 19.3462 15 18 15C16.6538 15 15.5625 16.0913 15.5625 17.4375C15.5625 18.7837 16.6538 19.875 18 19.875Z",
  fill: "#676F8F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30 19.875C31.3462 19.875 32.4375 18.7837 32.4375 17.4375C32.4375 16.0913 31.3462 15 30 15C28.6538 15 27.5625 16.0913 27.5625 17.4375C27.5625 18.7837 28.6538 19.875 30 19.875Z",
  fill: "#676F8F"
});

var SvgFace2 = function SvgFace2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFace2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face2.7c91baa2.svg";
export { ForwardRef as ReactComponent };